import React, { Component } from 'react';

class desafios_professor_encerrados extends Component {
    render() {
        return (
            <div>
                <h1>Encerrado</h1>
            </div>
        );
    }
}

export default desafios_professor_encerrados;


// WEBPACK FOOTER //
// ./src/components/professor/desafios/desafios_professor_encerrados.js